import styled from 'styled-components'

import { Button } from 'components/Button'
import { Container } from 'components/Container'
import { InboxNotice } from 'components/InboxNotice'

import { Color } from 'root-constants'

export const StyledAppWellness = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 100%;
    min-height: 0;
  `,
  Content: styled(Container)`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    max-width: 375px;
    padding: 16px 24px 0;
    margin: 0 auto;
  `,
  InboxNotice: styled(InboxNotice)`
    margin-bottom: 24px;
  `,
  Title: styled.p`
    font-size: 28px;
    font-weight: 700;
    line-height: 36px;
    text-align: center;
    color: ${Color.INK_DARKEST};
    margin-bottom: 12px;
  `,
  Subtitle: styled.p`
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    color: ${Color.INK_LIGHT};
    margin-bottom: 24px;
  `,
  PhoneImage: styled.img`
    flex-shrink: 0;
    width: calc(100% + 48px);
    max-width: none;
    margin: 0 -24px;
    -webkit-mask-image: linear-gradient(to bottom, #000 72%, transparent);
    mask-image: linear-gradient(to bottom, #000 72%, transparent);
  `,
  ButtonContainer: styled.div`
    position: sticky;
    bottom: 0;
    z-index: 2;
    display: flex;
    flex-direction: column;
    padding-bottom: env(safe-area-inset-bottom);

    &::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 50%;
      z-index: -1;
      width: 100vw;
      transform: translateX(-50%);
      pointer-events: none;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.75) 45%,
        rgba(255, 255, 255, 0.92) 100%
      );
    }
  `,
  DownloadButton: styled(Button)`
    width: 100%;
    max-width: 100%;
    height: 48px;

    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    white-space: nowrap;
    background-color: ${Color.INK_DARKEST};
    color: ${Color.GOLD_LIGHTER};

    padding: 16px 32px;
    margin: 24px 0 32px;
  `,
}
